import { useTenantStore } from '@/store/tenantStore';
import {
  getOnBoardingImageLayout,
  getOnBoardingImageSize,
  getOnBoardingImageUrl,
} from '@/services/tenant/tenantImages';
import { useLocalization } from '@/hooks/useLocalization';
import { translateDynamicContent } from '@/i18n';
import { MobileAuthHeader } from './MobileAuthHeader';
import styles from './MobileLoginIntro.module.css';

/**
 * MobileLoginIntro — what the login page shows above the sign-in form on mobile, in place of the
 * onboarding panel: the logo bar, onBoardingPage.headerText (f16b, black, 18px), the onboarding
 * image (its configured width, 50.h high, centered) and footerText (f14m, black, 14px).
 *
 * Mirrors the `ResponsiveUI.isMobile(context) && !state.isWebForgotPassword` children of Flutter
 * WebLoginForms (presentation/web/auth/web_login/web_login_forms.dart).
 */
export function MobileLoginIntro() {
  const { content } = useTenantStore();
  useLocalization(); // re-render when the language file loads or the language changes

  const page = content?.contentSettings?.onBoardingPage;
  const headerText = page?.headerText ? translateDynamicContent(page.headerText) : '';
  const footerText = page?.footerText ? translateDynamicContent(page.footerText) : '';
  const imageUrl = getOnBoardingImageUrl(content);
  const { width } = getOnBoardingImageSize(content);
  const { backgroundSize } = getOnBoardingImageLayout(content);

  return (
    <>
      <MobileAuthHeader />
      {headerText && <p className={styles.headerText}>{headerText}</p>}
      {imageUrl && (
        <div
          className={styles.image}
          style={{ width, backgroundImage: `url(${JSON.stringify(imageUrl)})`, backgroundSize }}
          aria-hidden
        />
      )}
      {footerText && <p className={styles.footerText}>{footerText}</p>}
    </>
  );
}
